import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type Card = {
    id: number
    title: string
    subtitle: string
    type: number[]
    subtext: string
    typeOfCard: number[]
    main: boolean
    groupId: number[]
    video: string
    gallery: string[]
    link: string
    preview: string
}

export type CardDto = {
    title: string
    subtitle: string
    type: number[]
    subtext: string
    typeOfCard: number[]
    main: boolean
    groupId: number[]
    video: string
    gallery: string[]
    link: string
    preview: string
}

export const cardApi = createApi({
    reducerPath: 'cardApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getAllCards: builder.query<Card[], void>({
            query: () => ({ url: `/card` })
        }),
        getCard: builder.query<Card, { id: number }>({
            query: ({ id }) => ({ url: `/card/${id}` })
        }),
        createCard: builder.mutation<any, CardDto>({
            query: (body) =>({url: `/card`, method: "POST", body: body})
        })
    })
})

export const { useGetAllCardsQuery, useGetCardQuery, useCreateCardMutation } = cardApi
